<div class="row">
    <div class="col-xs-12">
        <div class="job-match-meetings-statement">
            <span>{{meetingsLabel}}</span> for
                <span *ngIf="!loadingJobMatchInfoFlag">
                '<span class="emerald">{{candidateJobMatch.name}}</span>'
                for the role of '<span class="emerald">{{candidateJobMatch.jobMatchTitle}}</span>'
                <span *ngIf="candidateJobMatch.jobMatchClientName != null">at '<span class="emerald">{{ candidateJobMatch.jobMatchClientName }}</span>'</span>
            </span>
            <span *ngIf="loadingJobMatchInfoFlag">
                <span class="skeleton-paragraph skeleton-loading" style="display: inline-block; width: 200px; height: 14px; vertical-align: middle;"></span>
            </span>
        </div>
    </div>
</div>
<div class="row" [hidden]="loadingFlag">
    <div class="col-xs-12">
        <div class="table-responsive">
            <table class="table" id="meetingsTable">
                <thead>
                    <tr>
                        <th class="text-center">
                            <span>#</span>
                        </th>
                        <th class="text-center">
                            Scheduled Date
                        </th>
                        <th class="text-center">
                            Status
                        </th>
                        <th class="text-center">
                            Candidate Email Id
                        </th>
                        <!-- <th class="text-center">
                            Feedback Type
                        </th> -->
                        <th class="text-center">
                            {{ meetingUserType }} ( Email, Phone Number, Title )
                        </th>
                        <th class="text-center">
                            Mode
                        </th>
                        <th class="text-center">
                            View
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let meeting of meetingsList; let i = index">
                    <tr>
                        <td class="text-center">
                            {{ meeting.meetingCount}}
                        </td>
                        <td class="text-center candidate-job-match-text" [ngClass]="{'job-match-meetings-info-with-browser-time-zone-column': (meeting.timeZone != '-' && meeting.timeZone != browserTimeZone)}">
                            <div>{{ meeting.scheduledDateDisplay }}</div>
                            <div>{{ meeting.scheduledTimeLabel }}</div>
                            <div *ngIf="meeting.timeZone != '-'">
                                in {{ meeting.timeZone }}
                            </div>
                        </td>
                        <td class="text-center" [ngClass]="{'job-match-meetings-info-with-browser-time-zone-column': (meeting.timeZone != '-' && meeting.timeZone != browserTimeZone)}">
                            <span class="candidate-job-match-text">
                               {{ meeting.statusLabel}}
                            </span>
                            <span class="{{meeting.statusClass}}"></span>
                        </td>
                        <td class="text-center" [ngClass]="{'job-match-meetings-info-with-browser-time-zone-column': (meeting.timeZone != '-' && meeting.timeZone != browserTimeZone)}">
                            <span class="candidate-job-match-text">
                               {{ meeting.candidateEmail}}
                               <i [tooltip]="meeting.emailDeliveryReason" container="body" class="fas" [ngClass]="{'fa-check dark-green':meeting.emailSendToCandidate, 'fa-times red': !meeting.emailSendToCandidate}"></i>
                            </span>
                        </td>
                        <!-- <td class="text-center" [ngClass]="{'job-match-meetings-info-with-browser-time-zone-column': (meeting.timeZone != '-' && meeting.timeZone != browserTimeZone)}">
                            <span class="candidate-job-match-text">
                                <span *ngIf="meeting.feedbackType == 'INDIVIDUAL'" tooltip="Multiple Feedback" class="job-match-meetings-feedback-type-icon far fa-copy"></span>
                                <span *ngIf="meeting.feedbackType == 'SINGLE'" tooltip="Single Feedback" class="job-match-meetings-feedback-type-icon far fa-file"></span>
                            </span>
                        </td>  -->
                        <td class="text-center candidate-job-match-text" [ngClass]="{'job-match-meetings-info-with-browser-time-zone-column': (meeting.timeZone != '-' && meeting.timeZone != browserTimeZone)}">
                            <div *ngFor="let user of meeting.usersListToDisplay">
                                <p>{{ user.userName }} ( {{ user.email }}, {{ user.phoneNumber }},
                                    {{ user.title }} )
                                <i [tooltip]="user.emailDeliveryReason" container="body" class="fas" [ngClass]="{'fa-check dark-green':user.emailSendToParticipant, 'fa-times red': !user.emailSendToParticipant && !user.emailDeliveryReason.includes('not enabled'), 'fa-exclamation-circle gray':user.emailDeliveryReason.includes('not enabled')}"></i>
                                </p>
                            </div>
                        </td>
                        <td class="text-center candidate-job-match-text">
                            <span *ngIf="meeting.meetingMode == null"> - </span>
                            <span *ngIf="meeting.meetingMode !== null">
                                <i class="fas" [ngClass]="{'fa-video': meeting.meetingMode == 'VIDEO', 'fa-microphone': meeting.meetingMode == 'AUDIO', 'fa-phone': meeting.meetingMode == 'PHONE', 'fa-user-friends': meeting.meetingMode == 'FACE_TO_FACE'}"></i>
                            </span>
                        </td>
                        <td class="text-center candidate-job-match-text" [ngClass]="{'job-match-meetings-info-with-browser-time-zone-column': (meeting.timeZone != '-' && meeting.timeZone != browserTimeZone)}">
                            <span [tooltip]="notesTemplate" [tooltipContext]="{ notes: meeting.notesDisplay }" placement="top-right" container="body" style="position:relative; right:5px;">
                            </span>
                            <a *ngIf="meeting.notesDisplay.length>0" class="cursor-pointer" style="position:relative; right:5px;" [popover]="notesTemplate" [popoverContext]="{ notes: meeting.notesDisplay }" container="body" placement="top-right" triggers="outsideClick" containerClass="notes-popover">
                                <span class="fas fa-clipboard notes-icon"></span>
                            </a>
                            <span *ngIf="meeting.feedbackEnabledFlag && !meeting.isNotValid" [tooltip]="meeting.feedbackTooltip" container="body" (click)="openFeedbackForm(meeting)" class="fa fa-eye pointer"></span>
                            <!-- <a href="{{meeting.meetingUrl}}" target="_blank" style="color:black" *ngIf="meeting.feedbackEnabledFlag && !meeting.isNotValid" [tooltip]="meeting.feedbackTooltip" class="fa fa-eye pointer"></a> -->
                            <span *ngIf="!meeting.feedbackEnabledFlag && !meeting.isNotValid" [tooltip]="meeting.feedbackTooltip" container="body" class="fa fa-eye" style="opacity: 0.4"></span>
                        </td>
                    </tr>
                    <tr *ngIf="meeting.timeZone != '-' && meeting.timeZone != browserTimeZone">
                        <td colspan="4" class="job-match-meetings-browser-time-zone-column">
                            <div class="job-match-meetings-browser-time-zone-info text-center">
                                Schedule Date is '<strong>{{ meeting.scheduledDateInBrowserTimeZoneDisplay }} {{ meeting.scheduledTimeLabelInBrowserTimeZone }}</strong>' in your Computer's time zone (<strong>{{ browserTimeZone }}</strong>)
                            </div>
                            <div class="job-match-meetings-browser-time-zone-space">
                            </div>
                        </td>
                    </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="row" [hidden]="!loadingFlag">
    <div class="col-xs-12 text-center" style="padding-top: 20px">
        <div class="skeleton-paragraph skeleton-loading" style="width: 60%; margin: 0 auto 10px;"></div><div class="skeleton-paragraph skeleton-loading" style="width: 40%; margin: 0 auto;"></div>
    </div>
</div>

<ng-template #notesTemplate let-notes="notes">
    <span [innerHTML]="notes"></span>
</ng-template>
